import { IDefineCommand } from 'core-ts-types';

angular
  .module('major-explorer-data')
  .factory('getReminderAboutMajorsCommand', (defineCommand: IDefineCommand, $http: ng.IHttpService) => {
    return defineCommand('getReminderAboutMajorsCommand', (deferred: ng.IDeferred<any>) => {
      $http
        .get('core/studentvalue/')
        .then((response: any) => {
          deferred.resolve(response.data.has_advisor_reminder_about_majors === 'True'); // its a dictionary value on server
        })
        .catch((reject) => {
          deferred.resolve(reject);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/get_reminder_about_majors_command.ts